import React, { useState, forwardRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
  Typography,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SortBy({ open, onClose, onSortBy }) {
  const [selectedValue, setSelectedValue] = useState('Recommended');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    onSortBy(event.target.value)
  };

return (
    <Dialog
        open={open}
        onClose={onClose}
        slotProps={{ transition: Transition,
            paper: {
                sx: { borderRadius: '16px 16px 16px 16px', position: 'absolute', bottom: 0, width: '90%' },
            },
         }}
        fullWidth
        maxWidth="md"           
    >
        <DialogTitle>
            <Typography sx={{ fontWeight: 'bold' }}>
                Sort by
            </Typography>
        </DialogTitle>
        <DialogContent>
            <RadioGroup value={selectedValue} onChange={handleChange}>
                <FormControlLabel value="Recommended" control={<Radio />} label="Recommended" />
                {/* <FormControlLabel value="Newest" control={<Radio />} label="Newest" /> */}
                <FormControlLabel value="Lowest → Highest Price" control={<Radio />} label="Lowest → Highest Price" />
                <FormControlLabel value="Highest → Lowest Price" control={<Radio />} label="Highest → Lowest Price" />
            </RadioGroup>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setSelectedValue('Recommended')} sx={{ flex: 1, color: 'black' }}>
                Reset
            </Button>
            <Button onClick={onClose} variant="contained" sx={{ flex: 1, backgroundColor: 'black', color: 'white' }}>
                Done
            </Button>
        </DialogActions>
    </Dialog>
);
}